import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import Link from 'components/basic/Link/Link';
import LinkClickable from 'components/basic/Link/LinkClickable';
import RouterNavLink from 'components/basic/Link/RouterNavLink';

const customButtonStyle = css`
  height: 36px; /* 24 + padding */
  padding-left: 14px;
  color: var(--white);
  font-size: var(--medium);
  display: flex;
  align-items: center;

  &:hover {
    background: #272a3055;
  }
`;

const StyledLinkClickable = styled(LinkClickable)`
  ${customButtonStyle}
`;

const StyledNavLink = styled(RouterNavLink)<{ $partialHighlight?: boolean }>`
  ${customButtonStyle}
  color: var(--gray4c);
  .isMobileStyle & {
    color: var(--white);
  }
  position: relative;
  &.active {
    color: var(--white);
    // background: var(--separator);
  }
  &.active::after {
    content: '';
    position: absolute;
    right: 0;
    /* Compensate taller clickable area */
    height: calc(100% - 12px);
    width: 1px;
    ${({ $partialHighlight }) =>
      $partialHighlight
        ? '' // Used for submenu header
        : 'background: var(--white);'}
  }
`;

const customSubmenuButtonStyle = css`
  display: flex;
  align-items: center;
  height: 28px; /* 16 + padding */
  padding: 0 0 0 14px;
  margin-left: 32px;
  color: var(--gray4c);
  font-size: var(--small);
  position: relative;
  &.active {
    color: var(--white);
    /* background: var(--separator); */
  }
  &.active::after {
    content: '';
    position: absolute;
    right: 0;
    height: calc(100% - 4px);
    width: 1px;
    background: var(--white);
  }
`;

const StyledSubmenuClickable = styled(LinkClickable)`
  ${customSubmenuButtonStyle}
`;

const StyledSubmenuLink = styled(Link)`
  ${customSubmenuButtonStyle}
`;

const StyledSubNavLink = styled(RouterNavLink)`
  ${customSubmenuButtonStyle}
`;

export function VerticalMenuNavItem({
  children,
  icon,
  to,
  partialHighlight,
}: {
  children: ReactNode;
  icon?: ReactNode;
  to: string;
  partialHighlight?: boolean;
}) {
  return (
    <StyledNavLink to={to} $partialHighlight={partialHighlight}>
      {icon && (
        <>
          {icon}
          <span style={{ width: 16 }} />
        </>
      )}
      {children}
    </StyledNavLink>
  );
}

export function VerticalMenuClickableItem({
  children,
  icon,
  onClick,
}: {
  children: ReactNode;
  icon?: ReactNode;
  onClick?: () => void;
}) {
  return (
    <StyledLinkClickable
      onClick={
        onClick
          ? onClick
          : () => {
              //
            }
      }
    >
      {icon && (
        <>
          {icon}
          <span style={{ width: 16 }} />
        </>
      )}
      {children}
    </StyledLinkClickable>
  );
}

export const VerticalMenuWrap = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.5;
  padding-bottom: 6px;
`;

export function VerticalSubmenuClickableItem({
  children,
  onClick,
}: {
  children: ReactNode;
  onClick: () => void;
}) {
  return (
    <StyledSubmenuClickable onClick={onClick}>
      {children}
    </StyledSubmenuClickable>
  );
}

export function VerticalSubmenuNavItem({
  children,
  to,
}: {
  children: ReactNode;
  to: string;
}) {
  return (
    <StyledSubNavLink to={to} end>
      {children}
    </StyledSubNavLink>
  );
}

export function VerticalSubmenuLinkItem({
  children,
  href,
}: {
  children: ReactNode;
  href: string;
}) {
  return <StyledSubmenuLink href={href}>{children}</StyledSubmenuLink>;
}
